import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faHeart, faLink
} from '@fortawesome/free-solid-svg-icons';
import {
    faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook,
    faTwitter, faInstagram, faMedium, faBehance, faDribbble,
    faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud
} from '@fortawesome/free-brands-svg-icons';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../styles/TemplateEight.css';

const TemplateEight = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faLink,
        portfolio: faLink,
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud'
    };

    return (
        <div className="view-template-eight-container" onClick={() => onClick(template?.id)}>
            <div className="view-template-eight-header">
                {template?.image && <img src={template?.image} alt={template?.personName} className="view-template-eight-image " />}
                <div className="view-template-eight-name-title">
                    {template?.name && <h1 className="template-eight-name" >{template?.name}</h1>}

                </div>
            </div>
            <div className="view-template-eight-body">
                <div className="view-template-eight-column-left">
                    {template?.aboutMe && (
                        <div className="view-template-eight-section">
                            <h3>About Me</h3>
                            <p>{template?.aboutMe}</p>
                        </div>
                    )}
                    {template?.skills && template?.skills.length > 0 && (
                        <div className="view-template-eight-section">
                            <h3>Skills</h3>
                            <ul>
                                {template?.skills.map((skill, index) => (
                                    <li key={index}>{skill}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {template.softwareSkills && template.softwareSkills.length > 0 && (
                        <div className="view-template-eight-section">
                            <h3>Software Skills</h3>
                            <ul>
                                {template.softwareSkills.map((software, index) => (
                                    <li key={index}>{software}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {template?.languages && template?.languages.length > 0 && (
                        <div className="view-template-eight-section">
                            <h3>Languages</h3>
                            <ul>
                                {template?.languages.map((language, index) => (
                                    <li key={index}>{language}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {template?.languages && template.languages.length > 0 && (
                        <div className="view-template-eight-section">
                            <h3>Hobbies</h3>
                            <ul>
                                {template.hobbies.map((hobby, index) => (
                                    <li key={index}>{hobby}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                </div>
                <div className="view-template-eight-column-right">

                    {template.contact && (
                        <div className="view-template-eight-section">
                            <h3>Contact</h3>
                            {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} /> {template.contact.phone}</p>}
                            {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template.contact.email}</p>}
                            {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template.contact.address}</p>}
                        </div>
                    )}

                    {template?.workExperience && template?.workExperience.length > 0 && (
                        <div className="view-template-eight-section">
                            <h3>Work Experience</h3>
                            {template?.workExperience.map((experience, index) => (
                                <div key={index} className="view-template-eight-experience-item">
                                    <p className="view-template-eight-role">{experience.role}</p>
                                    <p className="view-template-eight-company-location">{experience.company} / {experience.location}</p>
                                    <p className="view-template-eight-date">
                                        {experience.location && (
                                            <p className="location">
                                                (
                                                {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                )
                                            </p>
                                        )}
                                    </p>
                                    <p className="view-template-eight-description">{experience.description}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    {template?.education && template?.education.length > 0 && (
                        <div className="view-template-eight-section">
                            <h3>Education</h3>
                            {template?.education.map((edu, index) => (
                                <div key={index} className="view-template-eight-education-item">
                                    <p className="view-template-eight-degree">{edu.degree}</p>
                                    <p className="view-template-eight-institution">{edu.institution}</p>
                                    <p>
                                        (
                                        {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                    <p className="view-template-eight-institution">{edu.description}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    {template?.certificates && (
                        <div className="view-template-eight-section">
                            <h3>Certificates</h3>
                            {template?.certificates.map((certificate, index) => (
                                <div key={index} className="view-template-eight-education-item">
                                    <p className="template-eleven-title">Title: {certificate.title}</p>
                                    <p className="template-eleven-institution">Institution: {certificate.institution}</p>
                                    <p className="template-eleven-date">
                                        Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}

                    {template?.links && template?.links.length > 0 && (
                        <div className="view-template-eight-section">
                            <h3>Links:</h3>
                            {template.links.map(([key, value]) => (
                                <p key={key} className="template-four-link">
                                    <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer"> <span className="template-three-link-text">{linkText[key]}</span></a>
                                </p>
                            ))}
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default TemplateEight;
